<section
  #host
  class="film film--{{ name() }}"
  [id]="anchor()"
  [class.film--orbit]="orbit()"
  [class.is-ready]="ready()"
  [class.is-fallback]="fallback()"
  [class.is-paused]="!playing()"
  [attr.data-chapter]="chapters()[chapter()].id"
  [attr.aria-label]="label()"
>
  <canvas #canvas class="film__canvas" aria-hidden="true"></canvas>
  <div class="film__fade" aria-hidden="true"></div>
  <div class="film__shade" aria-hidden="true"></div>
  <div class="film__grain" aria-hidden="true"></div>
  <div class="film__loading" aria-hidden="true"><span></span></div>

  <!-- labels pinned to points in the 3D scene; positioned by the stage every frame -->
  <div class="film__spots" aria-hidden="true">
    @for (h of hotspots(); track h.id) {
      <div class="spot" [class.spot--left]="h.side === 'l'" [class.spot--readout]="h.readout" [attr.data-spot]="h.id">
        <span class="spot__line"></span>
        <span class="spot__dot"></span>
        <span class="spot__label" data-label>{{ h.label }}</span>
      </div>
    }
  </div>

  @if (orbit()) {
    <!-- sits on the ring drawn round the subject; dragging it (or the picture) turns the view -->
    <button type="button" class="film__orbit" data-orbit aria-label="Drag to rotate the view, or use the left and right arrow keys">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 7-5 5 5 5" /></svg>
      <span>360°</span>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 7 5 5-5 5" /></svg>
    </button>
  }

  <div class="film__body container">
    <div class="film__copy">
      <div class="film__slides">
        @for (c of chapters(); track c.id; let i = $index) {
          <article
            class="slide"
            [class.is-active]="i === chapter()"
            [attr.aria-hidden]="i !== chapter()"
            [attr.inert]="i !== chapter() ? '' : null"
          >
            <p class="slide__kicker">
              <span class="slide__num">0{{ i + 1 }}</span>
              {{ c.kicker }}
            </p>
            @if (lead() && i === 0) {
              <h1 class="slide__title">{{ c.title }}</h1>
            } @else {
              <h2 class="slide__title">{{ c.title }}</h2>
            }
            <p class="slide__text">{{ c.body }}</p>
            @if (extra(); as tpl) {
              <ng-container *ngTemplateOutlet="tpl; context: { $implicit: c }" />
            }
          </article>
        }
      </div>

      @if (actions().length) {
        <div class="film__actions">
          @for (a of actions(); track a.label) {
            <a
              class="btn"
              data-clear-fabs
              [class.btn--primary]="a.kind === 'primary'"
              [class.btn--ghost]="a.kind === 'ghost'"
              [href]="a.href"
              [attr.target]="a.external ? '_blank' : null"
              [attr.rel]="a.external ? 'noopener' : null"
            >
              {{ a.label }}
              @if (a.kind === 'primary') {
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6" /></svg>
              }
            </a>
          }
        </div>
      }

      <div class="film__note"><ng-content select="[filmNote]" /></div>
    </div>
  </div>

  <div #bar class="film__bar container" data-clear-fabs>
    <button type="button" class="film__play" (click)="toggle()" [attr.aria-label]="playing() ? 'Pause the tour' : 'Play the tour'">
      @if (playing()) {
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z" /></svg>
      } @else {
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13l11-6.5z" /></svg>
      }
    </button>

    <ol class="timeline" aria-label="Tour chapters">
      @for (c of chapters(); track c.id; let i = $index) {
        <li class="timeline__item">
          <button
            type="button"
            class="timeline__seg"
            [class.is-active]="i === chapter()"
            [class.is-done]="i < chapter()"
            [attr.aria-current]="i === chapter() ? 'step' : null"
            (click)="goTo(i)"
          >
            <span class="timeline__track"><span class="timeline__fill"></span></span>
            <span class="timeline__label">{{ c.nav }}</span>
          </button>
        </li>
      }
    </ol>

    <p class="film__time" aria-hidden="true"><span #timecode>0:00</span> / {{ length() }}</p>
  </div>
</section>
